











































































































































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Guid } from "guid-typescript";
import moment from "moment";
import i18n from "@/i18n";
// components
import vSelect from "vue-select";
import PlayerReportAnalyticsModal from "@/components/reports/modals/PlayerReportAnalyticsModal.vue";
import PlayerReportExportModal from "@/components/reports/modals/PlayerReportExportModal.vue";
// service methods
import { getFilteredPlayers } from "@/services/reports/reportsService";
import { flatFolderStructure } from "@/services/folders/folderService";
// types
import { PlayersFilterDtoIn, PlayerReport } from "@/services/reports/types";
import { Option } from "@/services/common/types";
import { playerReportFields } from "@/components/reports/fields/playerReportFields";
import { PermitionEnum, HavePermition } from "@/components/security/Permitions";
import { FolderEntites, FolderOption } from "@/services/folders/types";

@Component({
    components: {
        vSelect,
        PlayerReportAnalyticsModal,
        PlayerReportExportModal
    }
})
export default class PlayersReport extends Vue {
    @Getter("getCurrentUser", { namespace: "authentication" }) getCurrentUser: any;
    // local state
    players = [] as Array<PlayerReport>;
    fields = playerReportFields;
    isBusy = false;
    permitionEnum = PermitionEnum;
    havePermition = HavePermition;
    sortBy = "playerName";
    sortDesc = false;
    Guid = Guid;
    folderEntities = FolderEntites;

    // filter
    selectedFolder = null as FolderOption | any;
    isActive = null as Option | any;

    // filter options
    playerStatus = [{ id: true, text: i18n.t("player.filterSelectActive") }, { id: false, text: i18n.t("player.filterSelectInactive") }];
    folderOptions = [] as FolderOption[];
    searchText = "" as string;
    playerTypes = [] as Array<Option>;
    selectedPlayerType = null as Option | any;

    // lifecycle hooks
    public created(): void {
        this.fetchData();
    }

    // methods & actions
    exportReport() {
        const playerIds = this.model.map(x => x.id);
        (this.$refs.playerReportExportModal as any).open(this.sortDesc, this.sortBy, playerIds);
    }

    fetchData() {
        this.loadPlayers();
        if (this.havePermition(this.getCurrentUser.permissions, this.permitionEnum[this.permitionEnum.AdminPrivilege])) {
            flatFolderStructure(this.folderEntities.Players).then(
                response => {
                    this.folderOptions = response;
                }
            );
        }
    }

    loadPlayers() {
        this.isBusy = true;
        this.players = [] as Array<PlayerReport>;
        getFilteredPlayers({
            placementFolderId: this.selectedFolder ? this.selectedFolder.id : "",
            location: Intl.DateTimeFormat().resolvedOptions().timeZone.split("/")[1]
        } as PlayersFilterDtoIn).then(response => {
            this.players = response;
            this.isBusy = false;

            const uniquePlayerTypes = [...new Set(
                this.players
                    .map(x => x.playerType ?? "") // ensure it's a string
                    .filter(playerType => playerType.trim() !== "")
            )];
            this.playerTypes = uniquePlayerTypes.map(playerType => ({
                id: playerType,
                text: playerType
            } as Option)).sort((a, b) => a.text.localeCompare(b.text));
        });
    }

    clearFilter() {
        this.selectedFolder = null;
        this.isActive = null;
        this.selectedPlayerType = null;
        this.loadPlayers();
    }

    formatDate(date: Date, type: string = "long") {
        if (date) {
            const localDate = moment.utc(date).local();

            if (type === "short") {
                return i18n.d(localDate.toDate(), "short");
            }

            if (type === "long") {
                return `${i18n.d(localDate.toDate(), "short")}, ${localDate.format("HH:mm")}`;
            }
        } else return "";
    }

    openPlayerAnalytics() {
        (this.$refs.playerReportAnalyticsModal as any).open();
    }

    get model(): Array<PlayerReport> {
        let result = this.players.filter(x => {
            const matchesSearch =
                this.searchText === "" ||
                x.playerName?.toLowerCase().includes(this.searchText.toLowerCase()) ||
                x.playerId?.toString().includes(this.searchText) ||
                x.playerFolderPath?.toLowerCase().includes(this.searchText.toLowerCase());

            const matchesPlayerType =
                !this.selectedPlayerType ||
                (x.playerType && this.selectedPlayerType.id &&
                    x.playerType.toLowerCase() === this.selectedPlayerType.id.toLowerCase());

            return matchesSearch && matchesPlayerType;
        });

        if (this.isActive !== null) {
            result = result.filter(x => this.isActive.id === x.isActive);
        }

        return result;
    }

    onSortChanged(ctx: any) {
        // Check if the sorted column is 'isActive'
        if (ctx.sortBy === "isActive") {
            // If 'isActive' is being sorted, ensure descending order
            this.sortDesc = true;
        } else {
            // For any other column, ensure ascending order
            this.sortDesc = false;
        }
    }
}
